import Sources from './Sources';

export const PAGE_SOURCES = '/sources';

export default Sources;
